// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { Message } from 'element-ui'
import { uploadFile } from '@/api/file'
import { editReportContent } from '@/api/lab/labexperiment2user'

export default {
    install(Vue) {
        // 保存为pdf操作
        Vue.prototype.getPdf = function() {
            let title = this.htmlTitle
            let type = this.htmlType
            let id = this.htmlId
            let element = document.querySelector('.pdf-box')
            let w = element.offsetHeight; // 获得该容器的宽
            let h = element.offsetWidth; // 获得该容器的高
            let offsetTop = element.offsetTop; // 获得该容器到文档顶部的距离
            let offsetLeft = element.offsetLeft; // 获得该容器到文档最左的距离
            let canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");
            let abs = 0;
            let win_i = document.documentElement.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
            let win_o = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

            if (win_o > win_i) {
                abs = (win_o - win_i) / 2; // 获得滚动条长度的一半
            }

            canvas.width = w * 2; // 将画布宽&&高放大两倍
            canvas.height = h * 2;
            context.scale(2, 2);
            context.translate(-offsetLeft - abs, -offsetTop);

            html2Canvas(element, {
                allowTaint: true
            }).then(canvas => {
                try {
                    let contentWidth = canvas.width
                    let contentHeight = canvas.height
                    let pageHeight = contentWidth / 592.28 * 841.89
                    let leftHeight = contentHeight
                    let position = 0
                    let imgWidth = 595.28
                    let imgHeight = 592.28 / contentWidth * contentHeight
                    let pageData = canvas.toDataURL('image/jpeg', 1.0)
                    let PDF = new JsPDF('', 'pt', 'a4')
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    if (type === 'current') {
                        PDF.save(title + '.pdf')
                    } else if (type === 'all') {
                        let buffer = PDF.output("datauristring")
                        let myfile = dataURLtoFile(buffer, title + '.pdf')
                        // 将pdf转文件类型上传到服务器,然后后端打包成zip,再提供下载
                        uploadFile(myfile, `lesson/exp/user/report/${id}/`).then(res => {
                            const { uid } = res
                            handEditReportContent(id, uid)
                        })
                    }
                } catch (e) {
                    window.console.error(e)
                }
            })
        }
    }
}

function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    //转换成file对象
    return new File([u8arr], filename, { type: mime });
    //转换成成blob对象
    //return new Blob([u8arr],{type:mime});
}

function handEditReportContent(id, reportFileUid) {
    let params = {
        id: id,
        reportFileUid: reportFileUid
    }
    editReportContent(params).then(() => {
        Message.success("PDF已生成")
    })
}
